'use client';

import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { initI18n } from '@/lib/i18n';

// 全局 i18n 实例 - 使用 window 对象来持久化
const getI18nInstance = () => {
  // 在浏览器环境中，使用 window 对象来持久化 i18n 实例
  if (typeof window !== 'undefined') {
    if (!(window as any).__i18nInstance) {
      (window as any).__i18nInstance = initI18n();
    }
    return (window as any).__i18nInstance;
  } else {
    // 服务端渲染时创建新实例
    return initI18n();
  }
};

interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * i18n 提供者组件
 * 用于包装整个应用，提供多语言支持
 */
export function I18nProvider({ children }: I18nProviderProps) {
  const i18n = getI18nInstance();
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (i18n.isInitialized) {
      // 检查 localStorage 中的语言设置
      if (typeof window !== 'undefined') {
        const savedLanguage = localStorage.getItem('i18nextLng');

        if (savedLanguage && savedLanguage !== i18n.language) {
          i18n.changeLanguage(savedLanguage);
        }
      }
      setIsReady(true);
    } else {
      i18n.on('initialized', () => {
        // 确保语言设置正确保存
        if (typeof window !== 'undefined') {
          const savedLanguage = localStorage.getItem('i18nextLng');

          if (savedLanguage && savedLanguage !== i18n.language) {
            i18n.changeLanguage(savedLanguage);
          }
        }
        setIsReady(true);
      });
    }
  }, [i18n]);

  if (!isReady) {
    return null;
  }

  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
}

